import React from 'react';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import { StyledLabel } from 'elements/Label/Label';
import PropTypes from 'prop-types';
import { FormInput } from 'elements/Inputs/FormInput/';
import { selectAltDensityTemplateForForm } from './ALT_DensitySection.data';

const DensitySectionAsLeft = (props) => {
    const { selectedTag, formName, changeHandler, formData, isFormReadOnly, userRole } = props;

    return (
        <div>
            {
                selectAltDensityTemplateForForm(selectedTag, formName, formData).rows.map(row => (
                    <Grid item container xs={12} key={row.key}>
                        {row.fields.map(field => (
                            <Grid item xs={field.xs} key={field.key}>
                                {field.isLabel
                                    ? (
                                        <StyledLabel
                                            id={field.key}
                                            fontWeight={field.fontWeight}
                                            fontSize={field.fontSize}
                                            textAlign={field.textAlign}
                                            labelWidth={field.labelWidth}
                                            padding={field.padding}
                                            direction={field.direction}
                                        >
                                            {field.label}
                                        </StyledLabel>
                                    )
                                    : (
                                        <FormInput
                                            id={field.key}
                                            name={field.key}
                                            label={field.label}
                                            value={field.value}
                                            isRequired={field.isRequired}
                                            isDisabled={field.isDisabled}
                                            handleChange={changeHandler}
                                            type={field.type}
                                            direction={field.direction}
                                            width={field.width}
                                            minWidth={field.minWidth}
                                            labelWidth={field.labelWidth}
                                            padding={field.padding}
                                            maxLength={field.maxLength}
                                            marginRight={field.marginRight}
                                            readOnly={field.readOnly || isFormReadOnly}
                                            marginLeft={field.marginLeft}
                                            textAlign={field.textAlign}
                                            borderBottom={field.borderBottom}
                                            borderRight={field.borderRight}
                                            userRole={userRole}
                                        />
                                    )}
                            </Grid>
                        )
                        )}
                    </Grid>
                ))
            }
        </div>
    );
};

const mapStateToProps = ({ Forms, Home }) => ({
    selectedTag: Forms.selectedTag,
    dpsData: Forms.dpsData,
    userRole: Home.userRole
});
const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DensitySectionAsLeft);

DensitySectionAsLeft.propTypes = {
    changeHandler: PropTypes.func,
    formData: PropTypes.object,
    formName: PropTypes.string,
    isFormReadOnly: PropTypes.bool,
    selectedTag: PropTypes.object,
    userRole: PropTypes.string,
};
